import { mediaQuery } from 'constants/ui';
import { getConditionalObject } from 'utils/data';

export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

export const borrowerStyles = {
  display: 'flex',
  gap: '10px',
  alignItems: 'center',
  overflow: 'hidden',
  flexWrap: 'wrap',
};

export const borrowerNameStyles = {
  fontSize: '2.4rem',
  fontWeight: 500,
  color: ({ palette }) => palette.text.primary,
  lineHeight: 1.2,
};

export const avatarStyles = {
  width: '40px',
  height: '40px',

  '& .initials': {
    fontSize: '1.6rem',
  },
};

export const contactsWrapperStyles = {
  display: 'flex',
  gap: '9px',
  alignItems: 'center',
  flexWrap: 'wrap',

  '& .contact-item-icon, & .separator': {
    color: ({ palette }) => palette.text.placeholder,
  },

  '& .contact-item-icon': {
    fontSize: '2.2rem',
  },

  '& .separator': {
    fontSize: '3.2rem',
    lineHeight: 0,
  },

  [mediaQuery.mobile]: {
    '& .separator': {
      display: 'none',
    },
  },
};

export const getContactItemWrapperStyles = isShrink => ({
  display: 'flex',
  gap: '9px',
  alignItems: 'center',
  overflow: 'hidden',

  ...getConditionalObject(!isShrink, {
    flexShrink: 0,
  }),
});

export const contactItemStyles = {
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
  color: ({ palette }) => palette.text.dark,
  overflow: 'hidden',
};

export const loanNumberButtonStyles = {
  padding: 0,
  fontWeight: 400,
  minWidth: 'unset',

  '&:hover': {
    background: 'none !important',
  },
};
